<template>
  <div>
    <!-- <VideoHeader
      :words="countWords"
      :ranking="getRank"
      :grammer="countLaws"
      :sentance="countSentences"
    /> -->
    <div class="main-chapter">
      <div v-if="!videos">
        {{ $t("video.video.loading") }}
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-if="playUrl" class="player">
        <h3>{{ playUrl.title }}</h3>
        <p>{{ playUrl.description }}</p>
        <VideoPlayer
          class="videoPlayer"
          :vidSrc="makeLinkEmbaddable(playUrl.url)"
        />
        <button class="done" @click="goBack">
          {{ $t("video.video.finish") }}
        </button>
      </div>
      <div v-else-if="videos" class="chapter-course">
        <div
          v-for="section of videos"
          :style="{
            height: calculateHeight(section)
          }"
          class="collapsed"
        >
          <div class="lesson-type" @click="pickType(section)">
            <div>
              <div>
                <h5>{{ section["title"] }}</h5>
              </div>
            </div>
            <div class="arrow-flex">
              <div class="arrow">
                <inline-svg
                  :src="require('../../assets/svg/arrow-down.svg').default"
                  :class="pickedType == section ? 'upside-arrow' : 'down-arrow'"
                ></inline-svg>
              </div>
            </div>
          </div>
          <div class="lessons-wrapper">
            <div
              v-for="videoa of section.lessons"
              @click="openLesson(videoa.id, videoa.permission)"
              :key="videoa.id"
              class="step "
              :class="{ completed: userProgress.includes(videoa.id) }"
            >
              <div class="v-stepper-course">
                <div class="circle">
                  <inline-svg
                    v-if="userProgress.includes(videoa.id)"
                    class="check-v-ex"
                    :src="require('../../assets/svg/GreenCheck.svg').default"
                  ></inline-svg>
                  <inline-svg
                    v-if="
                      videoa.permission !== 'unknown' &&
                        videoa.permission !== permission &&
                        permission !== 'paying' &&
                        videoa.permission == 'paying'
                    "
                    width="14px"
                    class="lockSign"
                    @click="goPay"
                    :src="require('../../assets/svg/lock.svg').default"
                  />
                  <inline-svg
                    v-if="
                      videoa.permission !== 'unknown' &&
                        videoa.permission !== permission &&
                        permission !== 'paying' &&
                        videoa.permission == 'registered'
                    "
                    width="14px"
                    class="lockSign"
                    :src="require('../../assets/svg/googleicon.svg').default"
                  />
                </div>
              </div>
              <div
                class="gameText"
                :class="{
                  disbaled:
                    videoa.permission !== 'unknown' &&
                    videoa.permission !== permission &&
                    permission !== 'paying'
                }"
              >
                {{ videoa.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="spacer"></div> -->
    </div>

    <!-- <VideoFooter class="video-footer-fixed" /> -->
  </div>
</template>

<script>
import "./Video.scss";

import Arrow from "../../assets/svg/arrow-left.svg";
import lesson from "../../assets/svg/lesson.svg";
import wordshalf from "../../assets/svg/wordshalf.svg";
import wordsfull from "../../assets/svg/wordsfull.svg";
import grammar from "../../assets/svg/grammar.svg";
import sentences from "../../assets/svg/sentences.svg";
import course from "../../store/course";
import VideoPlayer from "../Shared/VideoPlayer.vue";
import { courseService } from "../../services/courseService";

export default {
  name: "Video",
  props: ["permission"],
  data() {
    return {
      playUrl: null,
      // videos: null,
      chapter: null,
      pickedQa: null,
      sounds: false,
      speachSet: true,
      pickedType: "",
      Arrow,
      imgTypes: {
        lesson,
        wordshalf,
        wordsfull,
        grammar,
        sentences
      },
      types: {
        lesson: `שיעור`,
        wordshalf: `חצאי מילים`,
        wordsfull: `מילים`,
        sentences: `הרכבת משפטים`,
        grammar: `דקדוק`
      }
    };
  },
  async created() {
    // this.videos = await courseService.getVideos();
  },
  computed: {
    videos() {
      return this.$store.getters.videos;
    },
    numberOfQ() {
      const numberOfQ = 6;
      return numberOfQ;
    },
    user() {
      return this.$store.getters.user;
    },
    getRank() {
      if (this.user) {
        return this.user.user_rank;
      } else {
        return 0;
      }
    },
    countSentences() {
      if (this.user) {
        return this.user.sentences_score / 10;
      } else {
        return 0;
      }
    },
    countWords() {
      if (this.user) {
        return this.user.words_score;
      } else {
        return 0;
      }
    },
    countLaws() {
      if (this.user) {
        return this.user.rules_score / 5;
      } else {
        return 0;
      }
    },
    userProgress() {
      if (this.user && this.user.lessons) {
        return this.user.lessons
          .filter(lesson => lesson.is_done === true)
          .map(les => les.lesson.id);
      } else {
        return [];
      }
    }
  },
  methods: {
    openPlayer(url) {
      this.playUrl = url;
    },
    openLesson(id, permission) {
      if (permission === "paying" && this.permission !== "paying") {
        // this.text = "רק למשתמשים משלמים";
        // this.snacktype = "paid";
        // this.snackbar = true;
        // console.log("reg only");
        this.goPay();
        return;
      }
      if (
        permission !== "unknown" &&
        permission !== this.permission &&
        this.permission !== "paying"
      ) {
        this.goPay();
        return;
      }
      this.$router.push(`/lesson/${id}`);
    },
    goPay() {
      this.$router.push({
        path: `/registration`
      });
    },
    makeLinkEmbaddable: link => {
      if (String(link).includes("shorts")) {
        const youtubeID = String(link).split("/shorts/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=1&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      if (String(link).includes(".be/")) {
        const youtubeID = String(link).split(".be/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=1&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      const youtubeID = String(link).split("watch?v=")[1];
      return (
        "https://www.youtube.com/embed/" +
        youtubeID +
        "?autoplay=1&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
      );
    },
    calculateHeight(type) {
      console.log(type);
      return this.pickedType === type
        ? type.lessons.length * 60 + 70 + "px"
        : "54px";
    },
    pickType(type) {
      if (this.pickedType === type) {
        this.pickedType = "";
        return;
      }
      this.pickedType = type;
    },
    goBack() {
      this.playUrl = null;
    },
    goTo: function(lesson) {
      // this.$store.commit({
      //   type: "setCurrentGame",
      //   lesson,
      //   courseId: course.order,
      //   courseName: course.name
      // });
      // this.$router.push({
      //   path: `../play/${lesson.type}/${lesson.game_id}`
      // });
      console.log("OK");
    }
  },
  watch: {},
  components: { VideoPlayer }
};
</script>



// WEBPACK FOOTER //
// Video.vue?aa8a3488